import ApiService from './api.service'
import type {
  BudgetConsumptionReportResponse,
  TaskBudgetReportResponse,
  IntervenantBudgetReportResponse,
  TaskBudgetDetailsResponse
} from '@/types/services'

/**
 * Service for generating and exporting project reports
 */
class ReportService extends ApiService {
  constructor() {
    super({
      showNotifications: true,
      notificationOptions: {
        title: 'Project Report Error'
      }
    })
  }

  /**
   * Get comprehensive budget consumption report for a project
   */
  async getBudgetConsumptionReport(projectId: string): Promise<BudgetConsumptionReportResponse | null> {
    return this.get(`/api/project/${projectId}/reports/budget-consumption`)
  }

  /**
   * Get task budget reports for a project
   */
  async getTaskBudgetReport(projectId: string): Promise<TaskBudgetReportResponse | null> {
    return this.get(`/api/project/${projectId}/reports/tasks/budget`)
  }

  /**
   * Get intervenant budget reports for a project
   */
  async getIntervenantBudgetReport(projectId: string): Promise<IntervenantBudgetReportResponse | null> {
    return this.get(`/api/project/${projectId}/reports/intervenants/budget`)
  }

  /**
   * Get detailed budget information for a specific task
   */
  async getTaskBudgetDetails(projectId: string, taskId: string): Promise<TaskBudgetDetailsResponse | null> {
    return this.get(`/api/project/${projectId}/reports/tasks/${taskId}/budget`)
  }

  /**
   * Export budget consumption report as PDF
   */
  async exportBudgetReportPDF(projectId: string): Promise<Blob | null> {
    const locale = localStorage.getItem('locale') || 'en'
    return this.getBlob(`/api/project/${projectId}/reports/budget-consumption/export/pdf?lang=${locale}`)
  }

  /**
   * Export budget consumption report as Excel
   */
  async exportBudgetReportExcel(projectId: string): Promise<Blob | null> {
    return this.getBlob(`/api/project/${projectId}/reports/budget-consumption/export/excel`)
  }
}

export default new ReportService()
